export default __webpack_public_path__ + "static/project-slide-3-1248-765-5739c12eeda9c393357d74074e3a4f73.jpg";